import Image from "next/image";
import { FC, useEffect, useMemo } from "react";
import { getCurrentLocale } from "../i18n";
import { IPortfolio } from "../utils/types";

interface IPopupPortfolioProps {
  portfolio: IPortfolio | null;
  onClose: () => void;
}

const PopupPortfolio: FC<IPopupPortfolioProps> = ({ portfolio, onClose }) => {
  const currentLocale = getCurrentLocale();

  const handleBackgroundClick = (e: any) => {
    if (e.target.className === "popup") {
      onClose();
    }
  };

  useEffect(() => {
    document.ontouchmove = (event) => {
      // @ts-ignore
      if (event.target.className === "popup-content") {
        if (event.touches.length === 1) {
          event.preventDefault();
        }
      }
    };
    document.body.style.overflow = "hidden";
    return () => {
      document.ontouchmove = (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
      };
      document.body.style.overflow = "initial";
    };
  }, []);

  const html = useMemo(
    () =>
      currentLocale === "en"
        ? portfolio?.text_en
        : portfolio?.text,
    [portfolio]
  );

  useEffect(() => {
    if (html) {
      const main = document.querySelector('.ql-editor')
      const lazyImages = [].slice.call(main?.querySelectorAll("img.lazy"));
      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              // @ts-ignore
              lazyImage.src = lazyImage.dataset.src;
              entry.target.addEventListener('load', function removeLazy () {
                entry.target.classList.remove("lazy")
                entry.target.removeEventListener('load', removeLazy)
              });
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });
        lazyImages.forEach(function (lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }
    }
  }, [html]);
  
  return (
    <div className="popup-wrapper" onClick={handleBackgroundClick}>
      <input type="checkbox" className="popup-checkbox" id="popupCheckboxOne" />
      {/* <div className="popup without-background-popup"> */}
      <div className="popup">
        <div className="popup-content popup-content-portfolio">
          <label
            htmlFor="popupCheckboxOne"
            className="popup-closer"
            onClick={onClose}
          >
            &#215;
          </label>
          <div className="popup-view popup-view-portfolio">
            <div className="popup-view-img">
              {portfolio && (
                <img
                  className="popup-view-portfolio-img"
                  src={portfolio.image}
                  alt={
                    currentLocale === "en" ? portfolio.name_en : portfolio.name
                  }
                />
              )}
            </div>
            {portfolio && html && (
              <>
                {/* <h4 className="popup-view-portfolio-title">{currentLocale === 'en' ? portfolio.name_en : portfolio.name}</h4> */}
                <p
                  className="popup-view-portfolio-text ql-editor"
                  dangerouslySetInnerHTML={{ __html: html }}
                ></p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupPortfolio;
